import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Row, Spin, Tabs,} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, wdiCore, WdiInput, WdiStaffCard} from '@/components/WdiControls';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import {Enum} from '@/enums/system';
import {FormPageProps, WdiFormPageTitle} from '@/components/WdiBus/FormPage';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {initApprovalPageContext, ViewEntityProps} from "@/pages/sales/sp/PrePaymentApply/components/data";
import PrePaymentDetailsForApprovalPanel
  from "@/pages/sales/sp/PrePaymentApply/components/detail/PrePaymentDetailsForApprovalPanel";
import {approvalConfig} from "@/pages/sales/sp/components/data";
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import DynamicInformation from "@/pages/sales/sp/components/DynamicInformation";
import {SaViewApp} from "@/pages/sales/sa/components/SaViewApp";
import {OaFormApp} from "@/pages/sales/sp/components/OaContractCmpt";
import {OaForm} from "@/services/mdm/oaform";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";
import {DataOptions} from "@/services/basic/metadata";


const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/expenseapi/spButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        "TransferNodeButton",
        "AddMailApproverButton",
        "ExpediteFlowButton",
        "FormSpPrintButton"
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/spButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

const PrePaymentApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [spDetails, setSpDetails] = useState<API.FormSpDetail[]>([]);
  const [entity, setEntity] = useState<any>({});
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [!!(formRef?.current)])

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const res = await initApprovalPageContext(params);
        const viewEntity: ViewEntityProps = res?.data ?? {};
        if (props.setPageTitle) {
          let title = "预付申请单"
          const pageTypeName = viewEntity.formSp?.pageTypeName;
          const formNo = viewEntity.form?.formNo;
          const formStatusName = viewEntity.formSp?.statusName
          if (pageTypeName && formNo && formStatusName) {
            title = pageTypeName + `【${formNo}】` + `,` + formStatusName
          }
          props.setPageTitle(
            <WdiFormPageTitle
              title={title}
              onClose={props.onClose}
              callback={props.callback}
              form={viewEntity?.form}
              useCaseId={Enum.UseCase.SP}
              moreConfig={moreConfig}
              approvalConfig={approvalConfig}/>
          );
        }
        const formSp = viewEntity?.formSp;
        formRef.current?.setFieldsValue({
          paymentMethodName: formSp?.paymentMethodName,
          payTypeName: formSp?.payTypeName,
          bankAccountNo: formSp?.bankAccountNo,
          bankAccountName: formSp?.bankAccountName,
          fileInfo: FileUploadUtility.parse(formSp?.fileName, formSp?.filePath),
          remark: formSp?.remark,
          name: formSp?.name,
          amount: formSp?.amount,
          relatedSaNo: formSp?.relatedSa,
          voucherNo: formSp?.voucherNo,
          companyCodeOrName: wdiCore.String.CodeOrName(formSp?.companyCode, formSp?.companyName),
          supplierCodeOrName: wdiCore.String.CodeOrName(formSp?.supplierCode, formSp?.supplierName),
          payToUserCodeOrName: wdiCore.String.GenerateLabelDescription(wdiCore.String.CodeOrName(formSp?.payToUserNo, formSp?.payToUserName), formSp?.payToUserTitle),
          soldToCodeOrName: wdiCore.String.CodeOrName(formSp?.soldToCode, formSp?.soldToName),
          soldToCodePayTo: wdiCore.String.CodeOrName(formSp?.soldToCodePayTo, formSp?.soldToNamePayTo),
        })
        if (viewEntity?.formSp?.oaFormNo) {
          OaForm.get(viewEntity.formSp.oaFormNo).then(res => {
            formRef.current?.setFieldsValue({
              oaFormNo: res.data,
            });
          })
        }
        if(viewEntity?.formSp?.payToTypeId){
          DataOptions.search({typeGroup: 172,value:viewEntity.formSp.payToTypeId}).then(res=>{
            formRef.current?.setFieldsValue({
              payToTypeName: res?.data?.[0].name,
            })
          });
        }
        setEntity(viewEntity);
        setSpDetails(viewEntity.formSp?.preDetails ?? [])
      }
    })();
  }, [props.data]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId}/>
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>预付信息</span>} key="1">
          <ProForm
            className={'wdi-form'}
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>)
              },
            }}
          >
            <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.FORM_SP} title='预付单信息'/>}>
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="name" label="预付名称">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="payTypeName" label="支付类型">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="payToTypeName" label="支付给">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                {[Enum.PayToType.PAY_TO_SOLD_TO, Enum.PayToType.PAY_TO_SUPPLIER, Enum.PayToType.PAY_TO_STAFF].includes(entity?.formSp?.payToTypeId ?? 0) &&
                  <Col className="gutter-row" span={4}>
                    <Form.Item name="companyCodeOrName" label="公司">
                      <WdiInput readOnly/>
                    </Form.Item>
                  </Col>
                }
                {[Enum.PayToType.PAY_TO_SUPPLIER].includes(entity?.formSp?.payToTypeId ?? 0) &&
                  <Col className="gutter-row" span={4}>
                    <Form.Item name="supplierCodeOrName" label="供应商">
                      <WdiInput readOnly/>
                    </Form.Item>
                  </Col>
                }
                {[Enum.PayToType.PAY_TO_STAFF].includes(entity?.formSp?.payToTypeId ?? 0) &&
                  <Col className="gutter-row" span={4}>
                    <Form.Item name="payToUserCodeOrName" label="员工">
                      <WdiInput readOnly/>
                    </Form.Item>
                  </Col>
                }
                {[Enum.PayToType.SOLD_TO].includes(entity?.formSp?.payToTypeId ?? 0) &&
                  [
                    <Col className="gutter-row" span={4}>
                      <Form.Item name="soldToCodeOrName" label="客户">
                        <WdiInput readOnly/>
                      </Form.Item>
                    </Col>,
                    <Col className="gutter-row" span={4}>
                      <Form.Item name="soldToCodePayTo" label="收款客户">
                        <WdiInput readOnly/>
                      </Form.Item>
                    </Col>
                  ]
                }

                  <Col className="gutter-row" span={4}>
                    <Form.Item name="bankAccountNo" label="银行账号">
                      <WdiInput readOnly/>
                    </Form.Item>
                  </Col>


                <Col className="gutter-row" span={4}>
                    <Form.Item name="bankAccountName" label="户名">
                      <WdiInput readOnly/>
                    </Form.Item>
                  </Col>

                <Col className="gutter-row" span={4}>
                  <Form.Item name="amount" label="预付总金额">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="relatedSaNo" label="相关活动单号">
                    <SaViewApp/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="oaFormNo" label="OA合同号">
                    <OaFormApp/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="paymentMethodName" label="支付方式">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="voucherNo" label="外部系统编号">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="备注">
                    <WdiEditor readOnly={true}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
            <PrePaymentDetailsForApprovalPanel dataSource={spDetails}/>
          </ProForm>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="2">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={Enum.UseCase.PP}
            /> : <Spin/>
          }
        </TabPane>
      </Tabs>
    </>
  );
};
export default PrePaymentApprovalApp;
